// import React, { useState, useEffect, useCallback } from 'react';
// import { useLocation,useSearchParams } from 'react-router-dom';
// import Showp from './product';
// import './AllCategories.css';
// import { FaChevronUp, FaChevronDown } from 'react-icons/fa';
// import { IoIosArrowRoundForward } from "react-icons/io";
// import { HiOutlineChevronRight, HiOutlineChevronLeft } from "react-icons/hi";
// import MiniProductCard from './Miniproduct';
// import ProductCardimg from '../ShopProductCard/ProductCard';
// import PriceSlider from './Priceslider';
// import apple from '../Assets/greenapple.png';
// // import { getWithTokenAPI } from '../../util/Api';
// import { useSelector } from 'react-redux';

// import '../Topbarblog/Topbar.css';
// import down from '../../assets/down.svg';
// import filter from '../../assets/filter.svg';
// // import ProductCardimg from '../product/ProductCard';
// import chinse from '../../assets/ProductCardImg/chinseGarbage.jpeg';

// import Greencap from '../../assets/ProductCardImg/GreenCap.jpeg';
// import Redcap from '../../assets/ProductCardImg/RedCap.jpeg';
// import { getWithTokenAPI } from '../../util/Api';
// import { getWithoutTokenAPI } from '../../util/Api';
// import { useNavigate } from 'react-router-dom';
// import { BsCheckCircle, BsCheckCircleFill } from 'react-icons/bs';

// const initialCategories = [
//     { name: "Fresh Fruit", count: 54 },
//     { name: "Fresh Vegetables", count: 54 },
//     { name: "Meat & Fish", count: 54 },
//     { name: "Snacks", count: 54 },
//     { name: "Beverages", count: 54 },
//     { name: "Beauty & Health", count: 54 },
//     { name: "Bread & Bakery", count: 54 },
//     { name: "Baking Needs", count: 54 },
//     { name: "Cooking", count: 54 },
//     { name: "Diabetic Food", count: 54 },
//     { name: "Dish Detergents", count: 54 },
//     { name: "Oil", count: 54 },
// ];

// const AllCategories = ({ product }) => {
//     const location = useLocation();
//     const [products, setProducts] = useState([]);
//     const accessToken = useSelector((state) => state.auth?.access_token);

//     const [isCategoryOpen, setIsCategoryOpen] = useState(true);
//     const [isPriceOpen, setIsPriceOpen] = useState(true);
//     const [isRatingOpen, setIsRatingOpen] = useState(true);
//     const [isTagsOpen, setIsTagsOpen] = useState(true);
//     const [isSellerOpen, setIsSellerOpen] = useState(true);
//     const [selectedCategory, setSelectedCategory] = useState('');
//     const [selectedTags, setSelectedTags] = useState([]);
//     const [currentPage, setCurrentPage] = useState(1);
    
//     // State for mobile view detection
//     const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
//     // Initialize isFilterVisible: true for desktop, false for mobile
//     const [isFilterVisible, setIsFilterVisible] = useState(window.innerWidth >= 768);

//     const [tags, setTags] = useState([]);
//     const [productList, setProductList] = useState([]);
//     const [loading, setLoading] = useState(false);
//     const navigate = useNavigate();
//     const [selectedProduct, setSelectedProduct] = useState(null);
//     const [count, setCount] = useState();
//     const userId = useSelector((state) => state.auth?._id);
//     const [searchParams] = useSearchParams();
//     const sellerNameFromURL = searchParams.get('seller_name');
//     const sellerIdFromURL = searchParams.get('seller_id');
//     const categoryIdFromURL = searchParams.get('category_id');
//     const categoryNameFromURL = searchParams.get('category_name');
//     // const { selectedSellerId, selectedSeller } = location.state || {};
//     //new for categories
//     const [selectedCategoryId, setSelectedCategoryId] = useState(''); // Store selected category
//     const [categories, setCategories] = useState([]); // Store category list
//     const [selectedRating, setSelectedRating] = useState(null);
//     const [priceRange, setPriceRange] = useState({ min: 0, max: 500 });
//     const [debouncedPriceRange, setDebouncedPriceRange] = useState({ min: 0, max: 500 });
//     const [selectedSeller, setSelectedSeller] = useState({ id: '', name: '' });
//     const [uniqueSellers, setUniqueSellers] = useState([]);
//     const [sellers, setSellers] = useState([]); // Add new state for sellers

//     const ordersPerPage = 16;

//     // Effect to set selected category from location.state or URL parameters
//     useEffect(() => {
//         const stateCategoryId = location.state?.selectedCategoryId;
//         const stateCategoryName = location.state?.selectedCategoryName; // Corresponds to selectedCategory in state
    
//         // categoryIdFromURL and categoryNameFromURL are already defined from searchParams
    
//         let finalCategoryId = '';
//         let finalCategoryName = '';
//         let clearStateAfterProcessing = false;
    
//         if (stateCategoryId && stateCategoryName) {
//             finalCategoryId = stateCategoryId;
//             finalCategoryName = stateCategoryName;
//             clearStateAfterProcessing = true;
//         } else if (categoryIdFromURL && categoryNameFromURL) {
//             finalCategoryId = categoryIdFromURL;
//             finalCategoryName = decodeURIComponent(categoryNameFromURL);
//         }
//         // If neither state nor params provide a category, finalCategoryId/Name remain '', signifying "All Categories".
    
//         if (selectedCategoryId !== finalCategoryId || selectedCategory !== finalCategoryName) {
//             setSelectedCategoryId(finalCategoryId);
//             setSelectedCategory(finalCategoryName); // This state holds the category name for display/filtering logic
//             setCurrentPage(1); // Reset pagination
//         }
    
//         if (clearStateAfterProcessing) {
//             const newState = { ...location.state };
//             delete newState.selectedCategoryId;
//             delete newState.selectedCategoryName;
//             // Also clear the older selectedCategory if it exists from previous logic
//             delete newState.selectedCategory; 
            
//             if (location.state?.selectedCategoryId || location.state?.selectedCategoryName || location.state?.selectedCategory) {
//                 navigate(location.pathname + location.search, {
//                     replace: true,
//                     state: Object.keys(newState).length > 0 ? newState : {},
//                 });
//             }
//         }
//     }, [searchParams, location, navigate, selectedCategoryId, selectedCategory]);

//     useEffect(() => {
//         const fetchTags = async () => {
//             try {
//                 const response = await getWithoutTokenAPI('/tag/find-all');
//                 if (response?.statusCode === 200) {
//                     // Debug log
//                     setTags(response.data?.tags || []);
//                 }
//             } catch (error) {
//                 console.error("Error fetching tags:", error);
//             }
//         };

//         fetchTags();
//     }, []);

//     useEffect(() => {
//         const fetchProducts = async () => {
//             try {
//                 // Build query parameters
//                 const queryParams = new URLSearchParams();
//                 if (selectedSeller.id) {
//                     queryParams.append('seller_id', selectedSeller.id);
//                 }
//                 if (selectedCategoryId) {
//                     queryParams.append('category_id', selectedCategoryId);
//                 }
//                 if (selectedRating) {
//                     queryParams.append('min_rating', selectedRating);
//                 }
//                 if (debouncedPriceRange.min > 0) {
//                     queryParams.append('min_price', debouncedPriceRange.min);
//                 }
//                 if (debouncedPriceRange.max < 500) {
//                     queryParams.append('max_price', debouncedPriceRange.max);
//                 }
//                 // Add tags parameter if tags are selected
//                 if (selectedTags.length > 0) {
//                     const selectedTagIds = tags
//                         .filter(tag => selectedTags.includes(tag.name))
//                         .map(tag => tag._id);
                    
//                     if (selectedTagIds.length > 0) {
//                         queryParams.append('tags', selectedTagIds.join(','));
//                     }
//                 }

//                 // Only append user_id if it exists and is valid
//                 if (userId && userId.length === 24) {
//                     queryParams.append('user_id', userId);
//                 }

//                 const response = await getWithoutTokenAPI(`/product/find-all?${queryParams.toString()}`);
//                 if (response?.statusCode === 200) {
//                     // const products = response.data?.Product || [];
//                     const products = (response.data?.Product || []).filter(
//   (product) => product.Approval_status === "Approval"
// );


//                     // Get unique sellers from products
//                     const sellers = [...new Set(products.map(product => ({
//                         id: product.seller_id?._id,
//                         name: product.seller_id?.name
//                     })))].filter(seller => seller.id && seller.name);

//                     setUniqueSellers(sellers);

//                     // Attach seller name and ensure wish_status is included
//                     const updatedProducts = products.map((product) => ({
//                         ...product,
//                         sellerName: product.seller_id?.name || "Unknown Seller",
//                         wish_status: product.wish_status || false
//                     }));

//                     setProductList(updatedProducts);
//                 }
//             } catch (error) {
//                 console.error("Failed to fetch products:", error);
//             }
//         };

//         fetchProducts();
//     }, [selectedSeller.id, selectedCategoryId, selectedRating, debouncedPriceRange, selectedTags, tags, userId]);

//     useEffect(() => {
//         // Fetch category list (example API call, adjust as per your API)
//         const fetchCategories = async () => {
//             try {
//                 const response = await getWithoutTokenAPI('/category/find-all?Approval_status=Approval');
//                 if (response && response.statusCode === 200) {
//                     setCategories(response.data?.categories || []);
//                     response.data?.categories?.forEach(category => {
//                         // console.log(category._id);
//                     });
//                     setCount(response.data.total_count);

//                 }
//             } catch (error) {
//                 console.error("Error fetching categories:", error);
//             }
//         };

//         fetchCategories();
//     }, []);

//     // Add new useEffect to fetch sellers
//     useEffect(() => {
//         const fetchSellers = async () => {
//             try {
//                 const response = await getWithoutTokenAPI('/seller/find-all?role=seller');
//                 if (response?.statusCode === 200) {
//                     // Use all sellers from the User array
//                     const sellersList = response.data?.User || [];
//                     setSellers(sellersList);
//                     // Debug log
//                 }
//             } catch (error) {
//                 console.error("Error fetching sellers:", error);
//             }
//         };

//         fetchSellers();
//     }, []);

//     // const handleCategoryChange = (event) => {
//     //     setSelectedCategoryId(event.target.value);
//     // };

//     // const handleFindParticular = async (_id) => {
//     //     try {
//     //         const response = await getWithoutTokenAPI('/product/find-particular?_id=' + _id);
//     //         if (response && response.statusCode === 200) {
//     //             setSelectedProduct(response.data?.Product || []);
//     //             navigate(`/product?_id=${_id}`);
//     //             console.log(response.data?.Product);
//     //         }
//     //     } catch (error) {
//     //         console.error("Error fetching products:", error);
//     //     }
//     // };

//     const handleCategorySelect = (clickedCategoryName) => {
//         const currentSearchParams = new URLSearchParams(location.search);
//         const categoryIdInUrl = currentSearchParams.get('category_id');
    
//         let newCategoryIdForUrl = '';
//         let newCategoryNameForUrl = '';
    
//         if (clickedCategoryName === 'All Categories') {
//             // newCategoryIdForUrl and newCategoryNameForUrl remain ''
//         } else {
//             const categoryObject = categories.find(cat => cat.category_name === clickedCategoryName);
//             if (categoryObject) {
//                 // If the clicked category is already selected (based on ID in URL), then deselect it.
//                 if (categoryIdInUrl === categoryObject._id) {
//                     // newCategoryIdForUrl and newCategoryNameForUrl remain '' (deselect)
//                 } else {
//                     newCategoryIdForUrl = categoryObject._id;
//                     newCategoryNameForUrl = categoryObject.category_name;
//                 }
//             } else {
//                 // Clicked category name not found in the list, should not happen with current UI
//                 // Default to clearing filters as a safe fallback
//                 console.warn(`Category "${clickedCategoryName}" not found in fetched categories.`);
//             }
//         }
    
//         // Update search parameters
//         if (newCategoryIdForUrl && newCategoryNameForUrl) {
//             currentSearchParams.set('category_id', newCategoryIdForUrl);
//             currentSearchParams.set('category_name', encodeURIComponent(newCategoryNameForUrl));
//         } else {
//             currentSearchParams.delete('category_id');
//             currentSearchParams.delete('category_name');
//         }
    
//         const newSearchString = currentSearchParams.toString();
//         const targetPath = location.pathname + (newSearchString ? `?${newSearchString}` : '');
    
//         // Prepare new location state (clear out any consumed/stale category selection from navigation state)
//         const newState = { ...location.state };
//         delete newState.selectedCategoryId;
//         delete newState.selectedCategoryName;
//         delete newState.selectedCategory; // Clear older state key if present
    
//         // Only navigate if the target URL or state actually changes
//         if ((location.pathname + location.search) !== targetPath || 
//             location.state?.selectedCategoryId || location.state?.selectedCategoryName || location.state?.selectedCategory) {
//             navigate(targetPath, { 
//                 replace: true, 
//                 state: Object.keys(newState).length > 0 ? newState : {} 
//             });
//         }
//         // The useEffect hook listening to URL changes will handle setSelectedCategoryId, setSelectedCategory and setCurrentPage
//     };

//     // Effect to sync selectedTags state from 'tags' URL parameter
//     useEffect(() => {
//         const tagsQueryParam = searchParams.get('tags') || '';
//         // Decode tag names from URL before comparing/setting
//         const tagsArrayFromQuery = tagsQueryParam ? tagsQueryParam.split(',').map(tag => decodeURIComponent(tag)) : [];

//         // Sort for stable comparison to prevent unnecessary updates
//         const sortedCurrentSelectedTags = [...selectedTags].sort();
//         const sortedTagsArrayFromQuery = [...tagsArrayFromQuery].sort();

//         if (JSON.stringify(sortedCurrentSelectedTags) !== JSON.stringify(sortedTagsArrayFromQuery)) {
//             setSelectedTags(tagsArrayFromQuery);
//             setCurrentPage(1);
//         }
//     }, [searchParams]); // Removed selectedTags from dep array to avoid loops, URL is source of truth

//     // Effect to sync selectedRating state from 'rating' URL parameter
//     useEffect(() => {
//         const ratingQueryParam = searchParams.get('rating');
//         const ratingFromQuery = ratingQueryParam ? parseInt(ratingQueryParam, 10) : null;

//         if (selectedRating !== ratingFromQuery) {
//             setSelectedRating(ratingFromQuery);
//             setCurrentPage(1);
//         }
//     }, [searchParams]); // Removed selectedRating from dep array, URL is source of truth

//     const handleTagToggle = (clickedTagName) => {
//         const currentSearchParams = new URLSearchParams(location.search);
//         const currentTagsString = currentSearchParams.get('tags') || '';
//         // Decode from URL to work with actual names, then re-encode for URL
//         let currentTagArray = currentTagsString ? currentTagsString.split(',').map(tag => decodeURIComponent(tag)) : [];
    
//         if (currentTagArray.includes(clickedTagName)) {
//             currentTagArray = currentTagArray.filter(t => t !== clickedTagName);
//         } else {
//             currentTagArray.push(clickedTagName);
//         }
    
//         if (currentTagArray.length > 0) {
//             currentSearchParams.set('tags', currentTagArray.map(tag => encodeURIComponent(tag)).join(','));
//         } else {
//             currentSearchParams.delete('tags');
//         }
    
//         const newSearchString = currentSearchParams.toString();
//         const targetPath = location.pathname + (newSearchString ? `?${newSearchString}` : '');
    
//         const newState = { ...location.state }; // Preserve other state
    
//         if ((location.pathname + location.search) !== targetPath) {
//             navigate(targetPath, { 
//                 replace: true, 
//                 state: Object.keys(newState).length > 0 ? newState : {} 
//             });
//         }
//         // The useEffect listening to searchParams will update selectedTags state & trigger fetch
//     };

//     const handlePageChange = (page) => {
//         if (page >= 1 && page <= totalPages) {
//             setCurrentPage(page);
//         }
//     };

//     const handleRatingChange = (ratingValue) => {
//         const currentSearchParams = new URLSearchParams(location.search);
//         const currentRatingInUrl = currentSearchParams.get('rating');
//         const newRatingForUrl = String(ratingValue);

//         let updateUrl = false;

//         if (currentRatingInUrl === newRatingForUrl) {
//             // Clicked the same rating again, so deselect (remove from URL)
//             currentSearchParams.delete('rating');
//             updateUrl = true;
//         } else {
//             // Selected a new rating or first rating
//             currentSearchParams.set('rating', newRatingForUrl);
//             updateUrl = true;
//         }

//         if (updateUrl) {
//             const newSearchString = currentSearchParams.toString();
//             const targetPath = location.pathname + (newSearchString ? `?${newSearchString}` : '');
//             const newState = { ...location.state }; // Preserve other state

//             if ((location.pathname + location.search) !== targetPath) {
//                 navigate(targetPath, { 
//                     replace: true, 
//                     state: Object.keys(newState).length > 0 ? newState : {} 
//                 });
//             }
//         }
//         // The useEffect listening to searchParams will update selectedRating state & trigger fetch
//     };

//     // Debounced effect to update URL from priceRange (slider interaction)
//     useEffect(() => {
//         const timer = setTimeout(() => {
//             const currentSearchParams = new URLSearchParams(location.search);
//             const { min, max } = priceRange; // Current slider values from its own state

//             let changedInUrl = false;

//             // Handle min_price
//             const currentMinInUrl = currentSearchParams.get('min_price');
//             if (min > 0) { // Only add to URL if not default 0
//                 if (String(min) !== currentMinInUrl) {
//                     currentSearchParams.set('min_price', String(min));
//                     changedInUrl = true;
//                 }
//             } else { // min is 0 (default)
//                 if (currentMinInUrl) { // If it exists in URL (was not default), remove it
//                     currentSearchParams.delete('min_price');
//                     changedInUrl = true;
//                 }
//             }

//             // Handle max_price
//             const currentMaxInUrl = currentSearchParams.get('max_price');
//             if (max < 5000) { // Only add to URL if not default 5000
//                 if (String(max) !== currentMaxInUrl) {
//                     currentSearchParams.set('max_price', String(max));
//                     changedInUrl = true;
//                 }
//             } else { // max is 5000 (default)
//                 if (currentMaxInUrl) { // If it exists in URL (was not default), remove it
//                     currentSearchParams.delete('max_price');
//                     changedInUrl = true;
//                 }
//             }
            
//             if (changedInUrl) {
//                 const newSearchString = currentSearchParams.toString();
//                 const targetPath = location.pathname + (newSearchString ? `?${newSearchString}` : '');
                
//                 const newState = { ...location.state }; // Preserve other state
    
//                 // Check if navigation is actually needed to prevent loops if only defaults were managed
//                 if ((location.pathname + location.search) !== targetPath) {
//                     navigate(targetPath, { 
//                         replace: true, 
//                         state: Object.keys(newState).length > 0 ? newState : {} 
//                     });
//                 }
//                 // The useEffect listening to searchParams (below) will update debouncedPriceRange & trigger fetch
//             }
//         }, 700); // ~700ms delay, slightly longer than slider internal debounce

//         return () => clearTimeout(timer);
//     }, [priceRange, navigate, location.pathname, location.search]); // Listen to actual slider state

//     // Effect to sync priceRange (for slider UI) and debouncedPriceRange (for API) from URL parameters
//     useEffect(() => {
//         const minFromQuery = searchParams.get('min_price');
//         const maxFromQuery = searchParams.get('max_price');

//         const newMin = minFromQuery ? parseInt(minFromQuery, 10) : 0;
//         const newMax = maxFromQuery ? parseInt(maxFromQuery, 10) : 5000; // Default max price

//         let needsPageResetForDebounced = false;

//         // Update priceRange for the slider UI if it differs from URL
//         if (priceRange.min !== newMin || priceRange.max !== newMax) {
//             setPriceRange({ min: newMin, max: newMax }); 
//         }
        
//         // Update debouncedPriceRange for API if it differs from URL
//         if (debouncedPriceRange.min !== newMin || debouncedPriceRange.max !== newMax) {
//             setDebouncedPriceRange({ min: newMin, max: newMax });
//             needsPageResetForDebounced = true; 
//         }

//         if (needsPageResetForDebounced) {
//             setCurrentPage(1);
//         }
//     }, [searchParams, navigate]); // Listen to searchParams. priceRange and debouncedPriceRange removed to make URL source of truth.

//     const handlePriceChange = useCallback((min, max) => {
//         setPriceRange({ min, max });
//         // No longer directly setting debouncedPriceRange here, URL update will handle it.
//     }, []);

//     const handleSellerSelect = (sellerClicked) => {
//         const currentSearchParams = new URLSearchParams(location.search);
//         const sellerIdInUrl = currentSearchParams.get('seller_id');

//         let newSellerIdForUrl = sellerClicked.id;
//         let newSellerNameForUrl = sellerClicked.name;

//         // If the clicked seller is the one currently active in the URL (and not "All Sellers" itself),
//         // or if "All Sellers" is clicked, the result should be to clear seller filters in the URL.
//         if ( (sellerIdInUrl === sellerClicked.id && sellerClicked.id !== '') || // Clicking the active non-"All" seller
//               sellerClicked.id === ''                                         // Clicking "All Sellers"
//             ) {
//             newSellerIdForUrl = '';
//             newSellerNameForUrl = '';
//         }
//         // Otherwise, newSellerIdForUrl and newSellerNameForUrl are already set to sellerClicked values.
        
//         // Update search parameters
//         if (newSellerIdForUrl) {
//             currentSearchParams.set('seller_id', newSellerIdForUrl);
//             currentSearchParams.set('seller_name', newSellerNameForUrl);
//         } else {
//             currentSearchParams.delete('seller_id');
//             currentSearchParams.delete('seller_name');
//         }

//         const newSearchString = currentSearchParams.toString();
//         const targetPath = location.pathname + (newSearchString ? `?${newSearchString}` : '');

//         // Prepare new location state (clear out consumed seller selection from navigation state)
//         const newState = { ...location.state };
//         delete newState.selectedSellerId;
//         delete newState.selectedSeller;

//         // Only navigate if the target URL or state actually changes to avoid unnecessary actions
//         if (location.pathname + location.search !== targetPath || 
//             location.state?.selectedSellerId || location.state?.selectedSeller) {
//             navigate(targetPath, { replace: true, state: Object.keys(newState).length > 0 ? newState : {} });
//         }
//         // The useEffect hook listening to URL changes will handle setSelectedSeller and setCurrentPage
//     };

//     const filteredProducts = productList.filter(product => {
//         // Match category
//         const matchCategory = selectedCategory
//             ? product.category_id?._id === categories.find(cat => cat.category_name === selectedCategory)?._id
//             : true;

//         // Match rating
//         const matchRating = selectedRating
//             ? product.average_rating >= selectedRating
//             : true;

//         // Match seller (now using seller_id)
//         const matchSeller = selectedSeller.id
//             ? product.seller_id?._id === selectedSeller.id
//             : true;

//         return matchCategory && matchRating && matchSeller;
//     });
//     const totalPages = Math.ceil(filteredProducts.length / ordersPerPage);
//     const startIndex = (currentPage - 1) * ordersPerPage;
//     const currentProducts = filteredProducts.slice(startIndex, startIndex + ordersPerPage);

//     useEffect(() => {
//         if (location.state?.selectedCategory) {
//             setSelectedCategory(location.state.selectedCategory);
//         } else {
//             setSelectedCategory(''); // or any default
//         }
//     }, [location.state?.selectedCategory]);

//     // Effect to set selected seller from location.state or URL parameters
//     useEffect(() => {
//         const stateSellerId = location.state?.selectedSellerId;
//         const stateSellerName = location.state?.selectedSeller;

//         const paramSellerId = searchParams.get('seller_id');
//         const paramSellerName = searchParams.get('seller_name');

//         let finalSellerId = '';
//         let finalSellerName = '';
//         let clearStateAfterProcessing = false;

//         if (stateSellerId && stateSellerName) {
//             finalSellerId = stateSellerId;
//             finalSellerName = stateSellerName;
//             clearStateAfterProcessing = true; // Mark that location.state was used
//         } else if (paramSellerId && paramSellerName) {
//             finalSellerId = paramSellerId;
//             finalSellerName = paramSellerName;
//         }
//         // If neither state nor params provide a seller, finalSellerId/Name remain '', signifying "All Sellers".

//         // Only update component state if the determined seller is different from the current one
//         if (selectedSeller.id !== finalSellerId || selectedSeller.name !== finalSellerName) {
//             setSelectedSeller({ id: finalSellerId, name: finalSellerName });
//             setCurrentPage(1); // Reset pagination when seller changes
//         }

//         // If location.state was used, clear its specific seller properties
//         if (clearStateAfterProcessing) {
//             const newState = { ...location.state };
//             delete newState.selectedSellerId;
//             delete newState.selectedSeller;
            
//             // Check if navigation is actually needed (i.e., if state object actually had the keys)
//             // This prevents a navigation loop if the effect re-runs after state is already cleared.
//             if (location.state?.selectedSellerId || location.state?.selectedSeller) {
//                  navigate(location.pathname + location.search, { 
//                     replace: true, 
//                     state: Object.keys(newState).length > 0 ? newState : {} 
//                 });
//             }
//         }
//     // Dependencies: searchParams (derived from location.search), location object (for location.state), and navigate function.
//     }, [searchParams, location, navigate]);

//     // Update the results count to show seller name when filtering by seller
//     const resultsCount = () => {
//         if (selectedSeller.id) {
//             return `${filteredProducts.length} Results from ${selectedSeller.name}`;
//         } else if (selectedCategory) {
//             return `${filteredProducts.length} Results in ${selectedCategory}`;
//         }
//         return `${filteredProducts.length} Results Found`;
//     };

//     // Effect to handle window resize for mobile detection and filter visibility
//     useEffect(() => {
//         const handleResize = () => {
//             const currentIsMobile = window.innerWidth < 768;
//             if (currentIsMobile !== isMobile) {
//                 setIsMobile(currentIsMobile);
//                 // Reset filter visibility: closed by default on mobile, open by default on desktop
//                 setIsFilterVisible(!currentIsMobile);
//             }
//         };

//         window.addEventListener('resize', handleResize);
//         // Cleanup listener on component unmount
//         return () => window.removeEventListener('resize', handleResize);
//     }, [isMobile]); // Dependency on isMobile to correctly compare currentIsMobile with the state

//     const handleApplyFilters = () => {
//         setIsFilterVisible(false); // Close the filter sidebar, which will show products on mobile
//     };

//     return (
//         <>
//             <div className="top-bar-create">
//                 <button className="button" onClick={() => setIsFilterVisible(prev => !prev)}>
//                     Filters <img src={filter} alt="Filter Icon" />
//                 </button>

//                 {/* <div className="sort-container">
//                     <span>Sort by:</span>
//                     <div className="dropdown">
//                         <span>Latest</span>
//                         <img src={down} alt="Dropdown Icon" />
//                     </div>
//                 </div> */}

//                 <div className="results-count">
//                     {resultsCount()}
//                 </div>
//             </div>

//             <div className='shop'>
//                 <div className='main-content'>
//                     {isFilterVisible && (
//                         <aside className="categories-container">
//                             {/* Categories Section */}
//                             <div className="categories-header">
//                                 <h2 className="categories-title">All Categories</h2>
//                                 <div onClick={() => setIsCategoryOpen(prev => !prev)} className="categories-icon">
//                                     {isCategoryOpen ? <FaChevronUp /> : <FaChevronDown />}
//                                 </div>
//                             </div>

//                             {isCategoryOpen && (
//                                 <div className="categories-list">
//                                     <div
//                                         className={`category-item-shop ${selectedCategory === '' ? 'selected' : ''}`}
//                                         onClick={() => handleCategorySelect('All Categories')}
//                                     >
//                                         <div className={`custom-radio ${selectedCategory === '' ? 'selected' : ''}`}>
//                                             {selectedCategory === '' && <div className="inner-circle" />}
//                                         </div>
//                                         <div className="category-label">
//                                             <span className="category-name">All Categories</span>
//                                         </div>
//                                     </div>
//                                     {categories.map((cat) => (
//                                         <div
//                                             key={cat._id}
//                                             className={`category-item-shop ${selectedCategory === cat.category_name ? 'selected' : ''}`}
//                                             onClick={() => handleCategorySelect(cat.category_name)}
//                                         >
//                                             <div className={`custom-radio ${selectedCategory === cat.category_name ? 'selected' : ''}`}>
//                                                 {selectedCategory === cat.category_name && <div className="inner-circle" />}
//                                             </div>
//                                             <div className="category-label">
//                                                 <span className="category-name">{cat.category_name}</span>
//                                             </div>
//                                         </div>
//                                     ))}
//                                 </div>
//                             )}

//                             {/* Price Section */}
//                             <div className="price-filter-container">
//                                 {/* <div className="price-header" onClick={() => setIsPriceOpen(prev => !prev)}>
//                                     <h3 className="price-title">Price Range</h3>
//                                     {isPriceOpen ? <FaChevronUp /> : <FaChevronDown />}
//                                 </div> */}
//                                 {isPriceOpen && (
//                                     <PriceSlider 
//                                         onPriceChange={handlePriceChange}
//                                         minPrice={0}
//                                         maxPrice={5000}
//                                         initialMin={priceRange.min}
//                                         initialMax={priceRange.max}
//                                     />
//                                 )}
//                             </div>

//                             {/* Rating Section */}
//                             <div className="rating-filter-container">
//                                 <div className="rating-header" onClick={() => setIsRatingOpen(prev => !prev)}>
//                                     <h3 className="rating-title">Rating</h3>
//                                     {isRatingOpen ? <FaChevronUp /> : <FaChevronDown />}
//                                 </div>

//              {isRatingOpen && (
//   <div className="rating-options">
//     {[5, 4, 3, 2, 1].map((star) => (
//       <label key={star} className="rating-option">
//         <input 
//           type="checkbox" 
//           className='color-checkbox' 
//           name="rating" 
//           value={star}
//           checked={selectedRating === star}
//           onChange={() => handleRatingChange(star)}
//         />
//         {'⭐'.repeat(star)} {star}.0{star < 5 ? " & Up" : ""}
//       </label>
//     ))}
//   </div>
// )}

//                             </div>

//                             {/* Tags Section */}
//                             {/* <div className="popular-tags-container">
//                                 <div className="tags-header" onClick={() => setIsTagsOpen(prev => !prev)}>
//                                     <h3 className="tags-title">Popular Tags</h3>
//                                     {isTagsOpen ? <FaChevronUp /> : <FaChevronDown />}
//                                 </div>
//                                 {isTagsOpen && (
//                                     <div className="tags-list">
//                                         {tags && tags.length > 0 ? (
//                                             tags.map((tag) => (
//                                                 <span
//                                                     key={tag._id}
//                                                     className={`tag-item ${selectedTags.includes(tag.name) ? 'selected' : ''}`}
//                                                     onClick={() => handleTagToggle(tag.name)}
//                                                 >
//                                                     {tag.name}
//                                                 </span>
//                                             ))
//                                         ) : (
//                                             <p className="no-tags-message">No tags available</p>
//                                         )}
//                                     </div>
//                                 )}
//                             </div> */}

//                             {/* Seller Section */}
//                             <div className="seller-filter-container">
//                                 <div className="seller-header" onClick={() => setIsSellerOpen(prev => !prev)}>
//                                     <p className="seller-title">Seller Name</p>
//                                     {isSellerOpen ? <FaChevronUp /> : <FaChevronDown />}
//                                 </div>

//                                 {isSellerOpen && (
//                                     <div className="seller-filter-options">
//                                         <label className="seller-filter-option">
//                                             <input
//                                                 type="checkbox"
//                                                 className="seller-checkbox"
//                                                 name="seller"
//                                                 checked={!selectedSeller.id}
//                                                 onChange={() => handleSellerSelect({ id: '', name: '' })}
//                                             />
//                                             <span className="seller-label">All Sellers</span>
//                                         </label>
//                                         {sellers.map((seller) => (
//                                             <label key={seller._id} className="seller-filter-option">
//                                                 <input
//                                                     type="checkbox"
//                                                     className="seller-checkbox"
//                                                     name="seller"
//                                                     checked={selectedSeller.id === seller._id}
//                                                     onChange={() => handleSellerSelect({ 
//                                                         id: seller._id, 
//                                                         name: seller.name,
//                                                         profile_image: seller.profile_image 
//                                                     })}
//                                                 />
//                                                 <span className="seller-label">{seller.name}</span>
//                                             </label>
//                                         ))}
//                                     </div>
//                                 )}
//                             </div>

//                             {/* Apply Filters Button - Mobile Only */}
//                             {isMobile && isFilterVisible && (
//                                 <button
//                                     className="apply-filters-button"
//                                     onClick={handleApplyFilters}
//                                 >
//                                     Apply Filters
//                                 </button>
//                             )}
//                         </aside>
//                     )}
                    

//                     {/* Products Section - Conditionally render based on mobile and filter visibility */}
//                     {(!isMobile || (isMobile && !isFilterVisible)) && (
//                         <main className='products-section'>
//                             <div className="products-container">
//                                 {currentProducts.map((product) => (
//                                     <ProductCardimg 
//                                         key={product._id} 
//                                         product={{
//                                             ...product,
//                                             sellerName: product.seller_id?.name || "Unknown Seller",
//                                             wish_status: product.wish_status // Ensure wish_status is passed to ProductCardimg
//                                         }} 
//                                     />
//                                 ))}
//                             </div>

//                             {/* Pagination */}
//                             <div className="pageno">
//                                 <button
//                                     className="page-btn-right"
//                                     onClick={() => handlePageChange(currentPage - 1)}
//                                     disabled={currentPage === 1}
//                                 >
//                                     <HiOutlineChevronLeft />
//                                 </button>

//                                 {[...Array(totalPages)].map((_, index) => (
//                                     <button
//                                         key={index}
//                                         className={`page-btn-right ${currentPage === index + 1 ? 'active' : ''}`}
//                                         onClick={() => handlePageChange(index + 1)}
//                                     >
//                                         {index + 1}
//                                     </button>
//                                 ))}

//                                 <button
//                                     className="page-btn-right"
//                                     onClick={() => handlePageChange(currentPage + 1)}
//                                     disabled={currentPage === totalPages}
//                                 >
//                                     <HiOutlineChevronRight />
//                                 </button>
//                             </div>
//                         </main>
//                     )}
//                 </div>
//             </div>
//         </>
//     );
// };

// export default AllCategories;



"use client"

import { useState, useEffect, useCallback } from "react"
import { useLocation, useSearchParams } from "react-router-dom"
import "./AllCategories.css" // All CSS, including skeleton styles, is now in this file
import { FaChevronUp, FaChevronDown } from "react-icons/fa"
import { HiOutlineChevronRight, HiOutlineChevronLeft } from "react-icons/hi"
import ProductCardimg from "../ShopProductCard/ProductCard"
import PriceSlider from "./Priceslider"
// import { getWithTokenAPI } from '../../util/Api';
import { useSelector } from "react-redux"
import "../Topbarblog/Topbar.css"
import filter from "../../assets/filter.svg"
import { getWithoutTokenAPI } from "../../util/Api"
import { useNavigate } from "react-router-dom"
import productimg from '../../assets/a2.jpg'

// ProductCardSkeleton component defined directly in this file
const ProductCardSkeleton = () => {
  return (
    <div className="product-card-skeleton">
      <div className="product-card-skeleton-image"></div>
      <div className="product-card-skeleton-content">
        <div className="product-card-skeleton-line title"></div>
        <div className="product-card-skeleton-line subtitle"></div>
        <div className="product-card-skeleton-footer">
          <div className="product-card-skeleton-price"></div>
          <div className="product-card-skeleton-button"></div>
        </div>
      </div>
    </div>
  )
}

const initialCategories = [
  { name: "Fresh Fruit", count: 54 },
  { name: "Fresh Vegetables", count: 54 },
  { name: "Meat & Fish", count: 54 },
  { name: "Snacks", count: 54 },
  { name: "Beverages", count: 54 },
  { name: "Beauty & Health", count: 54 },
  { name: "Bread & Bakery", count: 54 },
  { name: "Baking Needs", count: 54 },
  { name: "Cooking", count: 54 },
  { name: "Diabetic Food", count: 54 },
  { name: "Dish Detergents", count: 54 },
  { name: "Oil", count: 54 },
]

const AllCategories = ({ product }) => {
  const location = useLocation()
  const [products, setProducts] = useState([])
  const accessToken = useSelector((state) => state.auth?.access_token)
  const [isCategoryOpen, setIsCategoryOpen] = useState(true)
  const [isPriceOpen, setIsPriceOpen] = useState(true)
  const [isRatingOpen, setIsRatingOpen] = useState(true)
  const [isTagsOpen, setIsTagsOpen] = useState(true)
  const [isSellerOpen, setIsSellerOpen] = useState(true)
  const [selectedCategory, setSelectedCategory] = useState("")
  const [selectedTags, setSelectedTags] = useState([])
  const [currentPage, setCurrentPage] = useState(1)
  // State for mobile view detection
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768)
  // Initialize isFilterVisible: true for desktop, false for mobile
  const [isFilterVisible, setIsFilterVisible] = useState(window.innerWidth >= 768)
  const [tags, setTags] = useState([])
  const [productList, setProductList] = useState([])
  const [loading, setLoading] = useState(true) // Changed to true initially
  const navigate = useNavigate()
  const [selectedProduct, setSelectedProduct] = useState(null)
  const [count, setCount] = useState()
  const userId = useSelector((state) => state.auth?._id)
  const [searchParams] = useSearchParams()
  const sellerNameFromURL = searchParams.get("seller_name")
  const sellerIdFromURL = searchParams.get("seller_id")
  const categoryIdFromURL = searchParams.get("category_id")
  const categoryNameFromURL = searchParams.get("category_name")
  // const { selectedSellerId, selectedSeller } = location.state || {};
  //new for categories
  const [selectedCategoryId, setSelectedCategoryId] = useState("") // Store selected category
  const [categories, setCategories] = useState([]) // Store category list
  const [selectedRating, setSelectedRating] = useState(null)
  const [priceRange, setPriceRange] = useState({ min: 0, max: 500 })
  const [debouncedPriceRange, setDebouncedPriceRange] = useState({ min: 0, max: 500 })
  const [selectedSeller, setSelectedSeller] = useState({ id: "", name: "" })
  const [uniqueSellers, setUniqueSellers] = useState([])
  const [sellers, setSellers] = useState([]) // Add new state for sellers
  const ordersPerPage = 16

  // Effect to set selected category from location.state or URL parameters
  useEffect(() => {
    const stateCategoryId = location.state?.selectedCategoryId
    const stateCategoryName = location.state?.selectedCategoryName // Corresponds to selectedCategory in state
    // categoryIdFromURL and categoryNameFromURL are already defined from searchParams
    let finalCategoryId = ""
    let finalCategoryName = ""
    let clearStateAfterProcessing = false

    if (stateCategoryId && stateCategoryName) {
      finalCategoryId = stateCategoryId
      finalCategoryName = stateCategoryName
      clearStateAfterProcessing = true
    } else if (categoryIdFromURL && categoryNameFromURL) {
      finalCategoryId = categoryIdFromURL
      finalCategoryName = decodeURIComponent(categoryNameFromURL)
    }
    // If neither state nor params provide a category, finalCategoryId/Name remain '', signifying "All Categories".

    if (selectedCategoryId !== finalCategoryId || selectedCategory !== finalCategoryName) {
      setSelectedCategoryId(finalCategoryId)
      setSelectedCategory(finalCategoryName) // This state holds the category name for display/filtering logic
      setCurrentPage(1) // Reset pagination
    }

    if (clearStateAfterProcessing) {
      const newState = { ...location.state }
      delete newState.selectedCategoryId
      delete newState.selectedCategoryName
      // Also clear the older selectedCategory if it exists from previous logic
      delete newState.selectedCategory

      if (
        location.state?.selectedCategoryId ||
        location.state?.selectedCategoryName ||
        location.state?.selectedCategory
      ) {
        navigate(location.pathname + location.search, {
          replace: true,
          state: Object.keys(newState).length > 0 ? newState : {},
        })
      }
    }
  }, [searchParams, location, navigate, selectedCategoryId, selectedCategory])

  useEffect(() => {
    setLoading(true) // Start loading for tags
    const fetchTags = async () => {
      try {
        const response = await getWithoutTokenAPI("/tag/find-all")
        if (response?.statusCode === 200) {
          // Debug log
          setTags(response.data?.tags || [])
        }
      } catch (error) {
        console.error("Error fetching tags:", error)
      } finally {
        setLoading(false) // End loading for tags
      }
    }
    fetchTags()
  }, [])

  useEffect(() => {
    setLoading(true) // Start loading for products
    const fetchProducts = async () => {
      try {
        // Build query parameters
        const queryParams = new URLSearchParams()
        if (selectedSeller.id) {
          queryParams.append("seller_id", selectedSeller.id)
        }
        if (selectedCategoryId) {
          queryParams.append("category_id", selectedCategoryId)
        }
        if (selectedRating) {
          queryParams.append("min_rating", selectedRating)
        }
        if (debouncedPriceRange.min > 0) {
          queryParams.append("min_price", debouncedPriceRange.min)
        }
        if (debouncedPriceRange.max < 500) {
          queryParams.append("max_price", debouncedPriceRange.max)
        }
        // Add tags parameter if tags are selected
        if (selectedTags.length > 0) {
          const selectedTagIds = tags.filter((tag) => selectedTags.includes(tag.name)).map((tag) => tag._id)

          if (selectedTagIds.length > 0) {
            queryParams.append("tags", selectedTagIds.join(","))
          }
        }
        // Only append user_id if it exists and is valid
        if (userId && userId.length === 24) {
          queryParams.append("user_id", userId)
        }
        const response = await getWithoutTokenAPI(`/product/find-all?${queryParams.toString()}`)
        if (response?.statusCode === 200) {
          // const products = response.data?.Product || [];
          const products = (response.data?.Product || []).filter((product) => product.Approval_status === "Approval")
          // Get unique sellers from products
          const sellers = [
            ...new Set(
              products.map((product) => ({
                id: product.seller_id?._id,
                name: product.seller_id?.name,
              })),
            ),
          ].filter((seller) => seller.id && seller.name)
          setUniqueSellers(sellers)
          // Attach seller name and ensure wish_status is included
          const updatedProducts = products.map((product) => ({
            ...product,
            sellerName: product.seller_id?.name || "Unknown Seller",
            wish_status: product.wish_status || false,
          }))
          setProductList(updatedProducts)
        }
      } catch (error) {
        console.error("Failed to fetch products:", error)
      } finally {
        setLoading(false) // End loading for products
      }
    }
    fetchProducts()
  }, [selectedSeller.id, selectedCategoryId, selectedRating, debouncedPriceRange, selectedTags, tags, userId])

  useEffect(() => {
    setLoading(true) // Start loading for categories
    // Fetch category list (example API call, adjust as per your API)
    const fetchCategories = async () => {
      try {
        const response = await getWithoutTokenAPI("/category/find-all?Approval_status=Approval")
        if (response && response.statusCode === 200) {
          setCategories(response.data?.categories || [])
          response.data?.categories?.forEach((category) => {
            // console.log(category._id);
          })
          setCount(response.data.total_count)
        }
      } catch (error) {
        console.error("Error fetching categories:", error)
      } finally {
        setLoading(false) // End loading for categories
      }
    }
    fetchCategories()
  }, [])

  // Add new useEffect to fetch sellers
  useEffect(() => {
    setLoading(true) // Start loading for sellers
    const fetchSellers = async () => {
      try {
        const response = await getWithoutTokenAPI("/seller/find-all?role=seller")
        if (response?.statusCode === 200) {
          // Use all sellers from the User array
          const sellersList = response.data?.User || []
          setSellers(sellersList)
          // Debug log
        }
      } catch (error) {
        console.error("Error fetching sellers:", error)
      } finally {
        setLoading(false) // End loading for sellers
      }
    }
    fetchSellers()
  }, [])

  // const handleCategoryChange = (event) => {
  //     setSelectedCategoryId(event.target.value);
  // };

  // const handleFindParticular = async (_id) => {
  //     try {
  //         const response = await getWithoutTokenAPI('/product/find-particular?_id=' + _id);
  //         if (response && response.statusCode === 200) {
  //             setSelectedProduct(response.data?.Product || []);
  //             navigate(`/product?_id=${_id}`);
  //             console.log(response.data?.Product);
  //         }
  //     } catch (error) {
  //         console.error("Error fetching products:", error);
  //     }
  // };

  const handleCategorySelect = (clickedCategoryName) => {
    const currentSearchParams = new URLSearchParams(location.search)
    const categoryIdInUrl = currentSearchParams.get("category_id")

    let newCategoryIdForUrl = ""
    let newCategoryNameForUrl = ""

    if (clickedCategoryName === "All Categories") {
      // newCategoryIdForUrl and newCategoryNameForUrl remain ''
    } else {
      const categoryObject = categories.find((cat) => cat.category_name === clickedCategoryName)
      if (categoryObject) {
        // If the clicked category is already selected (based on ID in URL), then deselect it.
        if (categoryIdInUrl === categoryObject._id) {
          // newCategoryIdForUrl and newCategoryNameForUrl remain '' (deselect)
        } else {
          newCategoryIdForUrl = categoryObject._id
          newCategoryNameForUrl = categoryObject.category_name
        }
      } else {
        // Clicked category name not found in the list, should not happen with current UI
        // Default to clearing filters as a safe fallback
        console.warn(`Category "${clickedCategoryName}" not found in fetched categories.`)
      }
    }

    // Update search parameters
    if (newCategoryIdForUrl && newCategoryNameForUrl) {
      currentSearchParams.set("category_id", newCategoryIdForUrl)
      currentSearchParams.set("category_name", encodeURIComponent(newCategoryNameForUrl))
    } else {
      currentSearchParams.delete("category_id")
      currentSearchParams.delete("category_name")
    }

    const newSearchString = currentSearchParams.toString()
    const targetPath = location.pathname + (newSearchString ? `?${newSearchString}` : "")

    // Prepare new location state (clear out any consumed/stale category selection from navigation state)
    const newState = { ...location.state }
    delete newState.selectedCategoryId
    delete newState.selectedCategoryName
    delete newState.selectedCategory // Clear older state key if present

    // Only navigate if the target URL or state actually changes
    if (
      location.pathname + location.search !== targetPath ||
      location.state?.selectedCategoryId ||
      location.state?.selectedCategoryName ||
      location.state?.selectedCategory
    ) {
      navigate(targetPath, {
        replace: true,
        state: Object.keys(newState).length > 0 ? newState : {},
      })
    }
    // The useEffect hook listening to URL changes will handle setSelectedCategoryId, setSelectedCategory and setCurrentPage
  }

  // Effect to sync selectedTags state from 'tags' URL parameter
  useEffect(() => {
    const tagsQueryParam = searchParams.get("tags") || ""
    // Decode tag names from URL before comparing/setting
    const tagsArrayFromQuery = tagsQueryParam ? tagsQueryParam.split(",").map((tag) => decodeURIComponent(tag)) : []
    // Sort for stable comparison to prevent unnecessary updates
    const sortedCurrentSelectedTags = [...selectedTags].sort()
    const sortedTagsArrayFromQuery = [...tagsArrayFromQuery].sort()
    if (JSON.stringify(sortedCurrentSelectedTags) !== JSON.stringify(sortedTagsArrayFromQuery)) {
      setSelectedTags(tagsArrayFromQuery)
      setCurrentPage(1)
    }
  }, [searchParams]) // Removed selectedTags from dep array to avoid loops, URL is source of truth

  // Effect to sync selectedRating state from 'rating' URL parameter
  useEffect(() => {
    const ratingQueryParam = searchParams.get("rating")
    const ratingFromQuery = ratingQueryParam ? Number.parseInt(ratingQueryParam, 10) : null
    if (selectedRating !== ratingFromQuery) {
      setSelectedRating(ratingFromQuery)
      setCurrentPage(1)
    }
  }, [searchParams]) // Removed selectedRating from dep array, URL is source of truth

  const handleTagToggle = (clickedTagName) => {
    const currentSearchParams = new URLSearchParams(location.search)
    const currentTagsString = currentSearchParams.get("tags") || ""
    // Decode from URL to work with actual names, then re-encode for URL
    let currentTagArray = currentTagsString ? currentTagsString.split(",").map((tag) => decodeURIComponent(tag)) : []

    if (currentTagArray.includes(clickedTagName)) {
      currentTagArray = currentTagArray.filter((t) => t !== clickedTagName)
    } else {
      currentTagArray.push(clickedTagName)
    }

    if (currentTagArray.length > 0) {
      currentSearchParams.set("tags", currentTagArray.map((tag) => encodeURIComponent(tag)).join(","))
    } else {
      currentSearchParams.delete("tags")
    }

    const newSearchString = currentSearchParams.toString()
    const targetPath = location.pathname + (newSearchString ? `?${newSearchString}` : "")

    const newState = { ...location.state } // Preserve other state

    if (location.pathname + location.search !== targetPath) {
      navigate(targetPath, {
        replace: true,
        state: Object.keys(newState).length > 0 ? newState : {},
      })
    }
    // The useEffect listening to searchParams will update selectedTags state & trigger fetch
  }

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page)
    }
  }

  const handleRatingChange = (ratingValue) => {
    const currentSearchParams = new URLSearchParams(location.search)
    const currentRatingInUrl = currentSearchParams.get("rating")
    const newRatingForUrl = String(ratingValue)
    let updateUrl = false
    if (currentRatingInUrl === newRatingForUrl) {
      // Clicked the same rating again, so deselect (remove from URL)
      currentSearchParams.delete("rating")
      updateUrl = true
    } else {
      // Selected a new rating or first rating
      currentSearchParams.set("rating", newRatingForUrl)
      updateUrl = true
    }
    if (updateUrl) {
      const newSearchString = currentSearchParams.toString()
      const targetPath = location.pathname + (newSearchString ? `?${newSearchString}` : "")
      const newState = { ...location.state } // Preserve other state
      // Check if navigation is actually needed to prevent loops if only defaults were managed
      if (location.pathname + location.search !== targetPath) {
        navigate(targetPath, {
          replace: true,
          state: Object.keys(newState).length > 0 ? newState : {},
        })
      }
    }
    // The useEffect listening to searchParams (below) will update selectedRating state & trigger fetch
  }

  // Debounced effect to update URL from priceRange (slider interaction)
  useEffect(() => {
    const timer = setTimeout(() => {
      const currentSearchParams = new URLSearchParams(location.search)
      const { min, max } = priceRange // Current slider values from its own state
      let changedInUrl = false
      // Handle min_price
      const currentMinInUrl = currentSearchParams.get("min_price")
      if (min > 0) {
        // Only add to URL if not default 0
        if (String(min) !== currentMinInUrl) {
          currentSearchParams.set("min_price", String(min))
          changedInUrl = true
        }
      } else {
        // min is 0 (default)
        if (currentMinInUrl) {
          // If it exists in URL (was not default), remove it
          currentSearchParams.delete("min_price")
          changedInUrl = true
        }
      }
      // Handle max_price
      const currentMaxInUrl = currentSearchParams.get("max_price")
      if (max < 5000) {
        // Only add to URL if not default 5000
        if (String(max) !== currentMaxInUrl) {
          currentSearchParams.set("max_price", String(max))
          changedInUrl = true
        }
      } else {
        // max is 5000 (default)
        if (currentMaxInUrl) {
          // If it exists in URL (was not default), remove it
          currentSearchParams.delete("max_price")
          changedInUrl = true
        }
      }

      if (changedInUrl) {
        const newSearchString = currentSearchParams.toString()
        const targetPath = location.pathname + (newSearchString ? `?${newSearchString}` : "")

        const newState = { ...location.state } // Preserve other state

        // Check if navigation is actually needed to prevent loops if only defaults were managed
        if (location.pathname + location.search !== targetPath) {
          navigate(targetPath, {
            replace: true,
            state: Object.keys(newState).length > 0 ? newState : {},
          })
        }
        // The useEffect listening to searchParams (below) will update debouncedPriceRange & trigger fetch
      }
    }, 700) // ~700ms delay, slightly longer than slider internal debounce
    return () => clearTimeout(timer)
  }, [priceRange, navigate, location.pathname, location.search]) // Listen to actual slider state

  // Effect to sync priceRange (for slider UI) and debouncedPriceRange (for API) from URL parameters
  useEffect(() => {
    const minFromQuery = searchParams.get("min_price")
    const maxFromQuery = searchParams.get("max_price")
    const newMin = minFromQuery ? Number.parseInt(minFromQuery, 10) : 0
    const newMax = maxFromQuery ? Number.parseInt(maxFromQuery, 10) : 5000 // Default max price
    let needsPageResetForDebounced = false
    // Update priceRange for the slider UI if it differs from URL
    if (priceRange.min !== newMin || priceRange.max !== newMax) {
      setPriceRange({ min: newMin, max: newMax })
    }

    // Update debouncedPriceRange for API if it differs from URL
    if (debouncedPriceRange.min !== newMin || debouncedPriceRange.max !== newMax) {
      setDebouncedPriceRange({ min: newMin, max: newMax })
      needsPageResetForDebounced = true
    }
    if (needsPageResetForDebounced) {
      setCurrentPage(1)
    }
  }, [searchParams, navigate]) // Listen to searchParams. priceRange and debouncedPriceRange removed to make URL source of truth.

  const handlePriceChange = useCallback((min, max) => {
    setPriceRange({ min, max })
    // No longer directly setting debouncedPriceRange here, URL update will handle it.
  }, [])

  const handleSellerSelect = (sellerClicked) => {
    const currentSearchParams = new URLSearchParams(location.search)
    const sellerIdInUrl = currentSearchParams.get("seller_id")
    let newSellerIdForUrl = sellerClicked.id
    let newSellerNameForUrl = sellerClicked.name
    // If the clicked seller is the one currently active in the URL (and not "All Sellers" itself),
    // or if "All Sellers" is clicked, the result should be to clear seller filters in the URL.
    if (
      (sellerIdInUrl === sellerClicked.id && sellerClicked.id !== "") || // Clicking the active non-"All" seller
      sellerClicked.id === ""
    ) {
      // Clicking "All Sellers"
      newSellerIdForUrl = ""
      newSellerNameForUrl = ""
    }
    // Otherwise, newSellerIdForUrl and newSellerNameForUrl are already set to sellerClicked values.

    // Update search parameters
    if (newSellerIdForUrl) {
      currentSearchParams.set("seller_id", newSellerIdForUrl)
      currentSearchParams.set("seller_name", newSellerNameForUrl)
    } else {
      currentSearchParams.delete("seller_id")
      currentSearchParams.delete("seller_name")
    }
    const newSearchString = currentSearchParams.toString()
    const targetPath = location.pathname + (newSearchString ? `?${newSearchString}` : "")
    // Prepare new location state (clear out consumed seller selection from navigation state)
    const newState = { ...location.state }
    delete newState.selectedSellerId
    delete newState.selectedSeller
    // Only navigate if the target URL or state actually changes to avoid unnecessary actions
    if (
      location.pathname + location.search !== targetPath ||
      location.state?.selectedSellerId ||
      location.state?.selectedSeller
    ) {
      navigate(targetPath, { replace: true, state: Object.keys(newState).length > 0 ? newState : {} })
    }
    // The useEffect hook listening to URL changes will handle setSelectedSeller and setCurrentPage
  }

  const filteredProducts = productList.filter((product) => {
    // Match category
    const matchCategory = selectedCategory
      ? product.category_id?._id === categories.find((cat) => cat.category_name === selectedCategory)?._id
      : true
    // Match rating
    const matchRating = selectedRating ? product.average_rating >= selectedRating : true
    // Match seller (now using seller_id)
    const matchSeller = selectedSeller.id ? product.seller_id?._id === selectedSeller.id : true
    return matchCategory && matchRating && matchSeller
  })

  const totalPages = Math.ceil(filteredProducts.length / ordersPerPage)
  const startIndex = (currentPage - 1) * ordersPerPage
  const currentProducts = filteredProducts.slice(startIndex, startIndex + ordersPerPage)

  useEffect(() => {
    if (location.state?.selectedCategory) {
      setSelectedCategory(location.state.selectedCategory)
    } else {
      setSelectedCategory("") // or any default
    }
  }, [location.state?.selectedCategory])

  // Effect to set selected seller from location.state or URL parameters
  useEffect(() => {
    const stateSellerId = location.state?.selectedSellerId
    const stateSellerName = location.state?.selectedSeller
    const paramSellerId = searchParams.get("seller_id")
    const paramSellerName = searchParams.get("seller_name")
    let finalSellerId = ""
    let finalSellerName = ""
    let clearStateAfterProcessing = false
    if (stateSellerId && stateSellerName) {
      finalSellerId = stateSellerId
      finalSellerName = stateSellerName
      clearStateAfterProcessing = true // Mark that location.state was used
    } else if (paramSellerId && paramSellerName) {
      finalSellerId = paramSellerId
      finalSellerName = paramSellerName
    }
    // If neither state nor params provide a seller, finalSellerId/Name remain '', signifying "All Sellers".
    // Only update component state if the determined seller is different from the current one
    if (selectedSeller.id !== finalSellerId || selectedSeller.name !== finalSellerName) {
      setSelectedSeller({ id: finalSellerId, name: finalSellerName })
      setCurrentPage(1) // Reset pagination when seller changes
    }
    // If location.state was used, clear its specific seller properties
    if (clearStateAfterProcessing) {
      const newState = { ...location.state }
      delete newState.selectedSellerId
      delete newState.selectedSeller

      // Check if navigation is actually needed (i.e., if state object actually had the keys)
      // This prevents a navigation loop if the effect re-runs after state is already cleared.
      if (location.state?.selectedSellerId || location.state?.selectedSeller) {
        navigate(location.pathname + location.search, {
          replace: true,
          state: Object.keys(newState).length > 0 ? newState : {},
        })
      }
    }
    // Dependencies: searchParams (derived from location.search), location object (for location.state), and navigate function.
  }, [searchParams, location, navigate])

  // Update the results count to show seller name when filtering by seller
  const resultsCount = () => {
    if (selectedSeller.id) {
      return `${filteredProducts.length} Results from ${selectedSeller.name}`
    } else if (selectedCategory) {
      return `${filteredProducts.length} Results in ${selectedCategory}`
    }
    return `${filteredProducts.length} Results Found`
  }

  // Effect to handle window resize for mobile detection and filter visibility
  useEffect(() => {
    const handleResize = () => {
      const currentIsMobile = window.innerWidth < 768
      if (currentIsMobile !== isMobile) {
        setIsMobile(currentIsMobile)
        // Reset filter visibility: closed by default on mobile, open by default on desktop
        setIsFilterVisible(!currentIsMobile)
      }
    }
    window.addEventListener("resize", handleResize)
    // Cleanup listener on component unmount
    return () => window.removeEventListener("resize", handleResize)
  }, [isMobile]) // Dependency on isMobile to correctly compare currentIsMobile with the state

  const handleApplyFilters = () => {
    setIsFilterVisible(false) // Close the filter sidebar, which will show products on mobile
  }

  return (
    <>
      <div className="top-bar-create">
        <button className="button" onClick={() => setIsFilterVisible((prev) => !prev)}>
          Filters <img src={filter || "/placeholder.svg"} alt="Filter Icon" />
        </button>
        {/* <div className="sort-container">
                    <span>Sort by:</span>
                    <div className="dropdown">
                        <span>Latest</span>
                        <img src={down || "/placeholder.svg"} alt="Dropdown Icon" />
                    </div>
                </div> */}
        <div className="results-count">{resultsCount()}</div>
      </div>
      <div className="shop">
        <div className="main-content">
          {isFilterVisible && (
            <aside className="categories-container">
              {/* Categories Section */}
              <div className="categories-header">
                <h2 className="categories-title">All Categories</h2>
                <div onClick={() => setIsCategoryOpen((prev) => !prev)} className="categories-icon">
                  {isCategoryOpen ? <FaChevronUp /> : <FaChevronDown />}
                </div>
              </div>
              {isCategoryOpen && (
                <div className="categories-list">
                  <div
                    className={`category-item-shop ${selectedCategory === "" ? "selected" : ""}`}
                    onClick={() => handleCategorySelect("All Categories")}
                  >
                    <div className={`custom-radio ${selectedCategory === "" ? "selected" : ""}`}>
                      {selectedCategory === "" && <div className="inner-circle" />}
                    </div>
                    <div className="category-label">
                      <span className="category-name">All Categories</span>
                    </div>
                  </div>
                  {loading
                    ? // Skeleton for categories
                      Array(5)
                        .fill(0)
                        .map((_, i) => (
                          <div key={i} className="category-item-skeleton skeleton-pulse">
                            <div className="radio-placeholder"></div>
                            <div className="category-label">
                              <div className="text-placeholder"></div>
                            </div>
                          </div>
                        ))
                    : categories.map((cat) => (
                        <div
                          key={cat._id}
                          className={`category-item-shop ${selectedCategory === cat.category_name ? "selected" : ""}`}
                          onClick={() => handleCategorySelect(cat.category_name)}
                        >
                          <div className={`custom-radio ${selectedCategory === cat.category_name ? "selected" : ""}`}>
                            {selectedCategory === cat.category_name && <div className="inner-circle" />}
                          </div>
                          <div className="category-label">
                            <span className="category-name">{cat.category_name}</span>
                          </div>
                        </div>
                      ))}
                </div>
              )}
              {/* Price Section */}
              <div className="price-filter-container">
                {/* <div className="price-header" onClick={() => setIsPriceOpen(prev => !prev)}>
                                    <h3 className="price-title">Price Range</h3>
                                    {isPriceOpen ? <FaChevronUp /> : <FaChevronDown />}
                                </div> */}
                {isPriceOpen && (
                  <PriceSlider
                    onPriceChange={handlePriceChange}
                    minPrice={0}
                    maxPrice={5000}
                    initialMin={priceRange.min}
                    initialMax={priceRange.max}
                  />
                )}
              </div>
              {/* Rating Section */}
              <div className="rating-filter-container">
                <div className="rating-header" onClick={() => setIsRatingOpen((prev) => !prev)}>
                  <h3 className="rating-title">Rating</h3>
                  {isRatingOpen ? <FaChevronUp /> : <FaChevronDown />}
                </div>
                {isRatingOpen && (
                  <div className="rating-options">
                    {loading
                      ? // Skeleton for ratings
                        Array(3)
                          .fill(0)
                          .map((_, i) => (
                            <div key={i} className="rating-option-skeleton skeleton-pulse">
                              <div className="checkbox-placeholder"></div>
                              <div className="text-placeholder"></div>
                            </div>
                          ))
                      : [5, 4, 3, 2, 1].map((star) => (
                          <label key={star} className="rating-option">
                            <input
                              type="checkbox"
                              className="color-checkbox"
                              name="rating"
                              value={star}
                              checked={selectedRating === star}
                              onChange={() => handleRatingChange(star)}
                            />
                            {`${"⭐".repeat(star)} ${star}.0${star < 5 ? " & Up" : ""}`}
                          </label>
                        ))}
                  </div>
                )}
              </div>
              {/* Tags Section */}
              {/* <div className="popular-tags-container">
                                <div className="tags-header" onClick={() => setIsTagsOpen(prev => !prev)}>
                                    <h3 className="tags-title">Popular Tags</h3>
                                    {isTagsOpen ? <FaChevronUp /> : <FaChevronDown />}
                                </div>
                                {isTagsOpen && (
                                    <div className="tags-list">
                                        {tags && tags.length > 0 ? (
                                            tags.map((tag) => (
                                                <span
                                                    key={tag._id}
                                                    className={`tag-item ${selectedTags.includes(tag.name) ? 'selected' : ''}`}
                                                    onClick={() => handleTagToggle(tag.name)}
                                                >
                                                    {tag.name}
                                                </span>
                                            ))
                                        ) : (
                                            <p className="no-tags-message">No tags available</p>
                                        )}
                                    </div>
                                )}
                            </div> */}
              {/* Seller Section */}
              <div className="seller-filter-container">
                <div className="seller-header" onClick={() => setIsSellerOpen((prev) => !prev)}>
                  <p className="seller-title">Seller Name</p>
                  {isSellerOpen ? <FaChevronUp /> : <FaChevronDown />}
                </div>
                {isSellerOpen && (
                  <div className="seller-filter-options">
                    <label className="seller-filter-option">
                      <input
                        type="checkbox"
                        className="seller-checkbox"
                        name="seller"
                        checked={!selectedSeller.id}
                        onChange={() => handleSellerSelect({ id: "", name: "" })}
                      />
                      <span className="seller-label">All Sellers</span>
                    </label>
                    {loading
                      ? // Skeleton for sellers
                        Array(3)
                          .fill(0)
                          .map((_, i) => (
                            <label key={i} className="seller-option-skeleton skeleton-pulse">
                              <div className="checkbox-placeholder"></div>
                              <div className="text-placeholder"></div>
                            </label>
                          ))
                      : sellers.map((seller) => (
                          <label key={seller._id} className="seller-filter-option">
                            <input
                              type="checkbox"
                              className="seller-checkbox"
                              name="seller"
                              checked={selectedSeller.id === seller._id}
                              onChange={() =>
                                handleSellerSelect({
                                  id: seller._id,
                                  name: seller.name,
                                  profile_image: seller.profile_image,
                                })
                              }
                            />
                            <span className="seller-label">{seller.name}</span>
                          </label>
                        ))}
                  </div>
                )}
              </div>
              {/* Apply Filters Button - Mobile Only */}
              {isMobile && isFilterVisible && (
                <button className="apply-filters-button" onClick={handleApplyFilters}>
                  Apply Filters
                </button>
              )}
            </aside>
          )}

          {/* Products Section - Conditionally render based on mobile and filter visibility */}
      {(!isMobile || (isMobile && !isFilterVisible)) && (
  <main className="products-section">
    <div className="products-container">
      {loading ? (
        // Skeleton loaders for products
        Array(ordersPerPage)
          .fill(0)
          .map((_, index) => <ProductCardSkeleton key={index} />)
      ) : (
        currentProducts.map((product) => (
          <ProductCardimg
            key={product._id}
            product={{
              ...product,
              sellerName: product.seller_id?.name || "Unknown Seller",
              wish_status: product.wish_status, // Ensure wish_status is passed to ProductCardimg
            }}
          />
        ))
      )}
    </div>

    {/* "No products available" message moved outside of the main product display logic */}
    {!loading && filteredProducts.length === 0 && (
      <div className="empty-wishlist-container">
        <div className="empty-wishlist-content">
          <div className="d-flex justify-content-center">
            <img src={productimg} className="empty-wish-img" alt="no product" style={{ width: "30%" }} />
          </div>
          <div className="empty-wishlist-message mt-2">
            <h3>No products available</h3>
            <p>We’re working on adding amazing products. Stay tuned!</p>
          </div>
        </div>
      </div>
    )}

    {/* Pagination */}
    {!loading &&
      filteredProducts.length > 0 && ( // Only show pagination if not loading and products exist
        <div className="pageno">
          <button
            className="page-btn-right"
            onClick={() => handlePageChange(currentPage - 1)}
            disabled={currentPage === 1}
          >
            <HiOutlineChevronLeft />
          </button>
          {[...Array(totalPages)].map((_, index) => (
            <button
              key={index}
              className={`page-btn-right ${currentPage === index + 1 ? "active" : ""}`}
              onClick={() => handlePageChange(index + 1)}
            >
              {index + 1}
            </button>
          ))}
          <button
            className="page-btn-right"
            onClick={() => handlePageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
          >
            <HiOutlineChevronRight />
          </button>
        </div>
      )}
  </main>
)}
        </div>
      </div>
    </>
  )
}

export default AllCategories

